import { api } from "./api";

export interface PlayerCouponItem {
  _id: string;
  name: string;
  image?: {
    small?: { url: string };
    medium?: { url: string };
    original?: { url: string };
  };
}

export interface PlayerCoupon {
  _id: string;
  url: string;
  filename: string;
  assigned?: number | string | { $date: string };
  achievement: string;
  item: PlayerCouponItem;
}

export async function getPlayerCoupons(): Promise<PlayerCoupon[]> {
  try {
    const { data } = await api.post("find/player_coupons", {});
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Error al cargar los cupones del jugador:", error);
    return [];
  }
}

export async function getCouponByAchievement(
  achievementId: string,
): Promise<PlayerCoupon | null> {
  if (!achievementId) return null;
  const coupons = await getPlayerCoupons();
  return coupons.find((coupon) => coupon.achievement === achievementId) || null;
}

export function parseCouponDate(
  value?: PlayerCoupon["assigned"],
): Date | null {
  if (!value) return null;
  const raw = typeof value === "object" ? value.$date : value;
  const date = new Date(raw);
  return isNaN(date.getTime()) ? null : date;
}

export function isPdfCoupon(coupon: PlayerCoupon): boolean {
  return [coupon.filename, coupon.url].some((value) =>
    (value || "").split("?")[0].toLowerCase().endsWith(".pdf"),
  );
}

export async function downloadCoupon(coupon: PlayerCoupon): Promise<void> {
  try {
    const response = await fetch(coupon.url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = coupon.filename || "cupon";
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(coupon.url, "_blank", "noopener");
  }
}
